import React from 'react';
import {
    Div,
    ProductsContainer,
    ItemTitle,
    Description,
    ItemsNotAllowedText,
    ExclusionItemsNotAllowedDiv,
    ButtonFooter,
} from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { detectDeviceInfo } from 'src/utils/util';
import { hideScrolling, resumeScrolling } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// import { ItemsNotAllowedText } from 'src/pages/consignmentAdd/components/common/notifications/Notifications.styled';

const ThresholdAndCumulativeLimitError = ({
    onClose,
    title,
    opacity = 10,
    productsNotAddedToCart,
    message,
    content,
    isSurgery,
    countryISOCode,
    footerMessage,
}) => {
    const { t } = useTranslation();
    const { deviceType, browser, deviceName } = detectDeviceInfo();
    const { isLanguageChanged } = useSelector((state) => state.loginReducer);
    return (
        <>
            <Popup
                title={title}
                onClose={onClose}
                width={'300px'}
                webWidth={'352px'}
                webHeight={isSurgery ? '' : '78px'}
                fontSize={'17px'}
                opacity={opacity}
                flexDirection={'column'}
                id={'surgery-notification-thresholdAndCumulativeLimitError-popup'}
            >
                <Div
                    flexShink={'0'}
                    webkitFlex={'0'}
                    justifyContent={'center'}
                    position={'relative'}
                >
                    {isSurgery ? (
                        // && (countryISOCode === "US" || countryISOCode==="JP")
                        <div>
                            <ExclusionItemsNotAllowedDiv
                                mbHeight={message ? '' : 'auto'}
                                height={message ? '' : 'auto'}
                                width={message ? '' : '500px'}
                            >
                                <ItemsNotAllowedText
                                    fontFamily={
                                        message ? '' : 'AvenirNextWorld Regular'
                                    }
                                    color={message ? '' : '#000000'}
                                    height={message ? '' : 'auto'}
                                >
                                    {' '}
                                    {message ? (
                                        message
                                    ) : content ? (
                                        <span
                                            style={{
                                                textAlign: 'left',
                                                width: isLanguageChanged
                                                    ? '100%'
                                                    : '99%',
                                            }}
                                        >
                                            {content}
                                            <br />
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                </ItemsNotAllowedText>

                                {!message ? (
                                    <div
                                        style={{
                                            maxHeight: '200px',
                                            overflow: 'auto',
                                            marginTop: '15px',
                                        }}
                                    >
                                        {productsNotAddedToCart?.length > 0 &&
                                            productsNotAddedToCart.map(
                                                (product, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                        }}
                                                    >
                                                        <ItemTitle
                                                            mbFlexBasis={'100%'}
                                                            flexBasis={'100%'}
                                                            key={index}
                                                        >
                                                            {`${
                                                                product?.productCFN
                                                                    ? product.productCFN
                                                                    : product.cfn
                                                            } - `}
                                                            {product
                                                                ?.description
                                                                ?.length
                                                                ? product
                                                                      .description[0] +
                                                                  product.description
                                                                      .slice(1)
                                                                      .toLowerCase()
                                                                : ''}
                                                        </ItemTitle>
                                                        {/* <Description mbFlexBasis={'100%'} flexBasis={'100%'}>
                                       {product?.description?.length
                                            ? product.description[0] +
                                              product.description
                                                  .slice(1)
                                                  .toLowerCase()
                                            : ''}
                                    </Description> */}
                                                    </div>
                                                )
                                            )}
                                    </div>
                                ) : (
                                    productsNotAddedToCart?.length > 0 && (
                                        <ProductsContainer
                                            isProductTemplateExclusionItems={
                                                true
                                            }
                                            onPointerMove={resumeScrolling}
                                            onTouchMove={resumeScrolling}
                                            onTouchEnd={hideScrolling}
                                            scrollBarWidth={'5px'}
                                            scrollBarBackgroundColor={'#888'}
                                            scrollBarBorderRadius={'10px'}
                                            scrollbarHeight={'2rem'}
                                            scrollBarBackGroundColorOnHover={
                                                '#555'
                                            }
                                            mobileDeviceScrollBarDisplay={
                                                'block'
                                            }
                                            mediumDeviceScrollBarDisplay={
                                                'block'
                                            }
                                        >
                                            {productsNotAddedToCart.map(
                                                (product, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                        }}
                                                    >
                                                        <ItemTitle key={index}>
                                                            {product.productCFN}
                                                        </ItemTitle>
                                                        <Description>
                                                            {product
                                                                ?.description
                                                                ?.length
                                                                ? product
                                                                      .description[0] +
                                                                  product.description
                                                                      .slice(1)
                                                                      .toLowerCase()
                                                                : ''}
                                                        </Description>
                                                    </div>
                                                )
                                            )}
                                        </ProductsContainer>
                                    )
                                )}
                            </ExclusionItemsNotAllowedDiv>
                            <ButtonFooter
                                showCancelButton={true}
                                center={true}
                                mbPosition={'relative'}
                            >
                                <Button
                                    id={'surgery-notifications-thresholdandcumulativelimiterror-okbutton'}
                                    show={true}
                                    width={'150px'}
                                    height={'36px'}
                                    // primary={true}
                                    variant={ButtonStyles?.primary}
                                    margin={'5px'}
                                    fontSize={'14.5px'}
                                    clicked={onClose}
                                >
                                    {t('common.continueLowerCaseButton')}
                                </Button>
                            </ButtonFooter>
                        </div>
                    ) : (
                        <Button
                          id={'surgery-notifications-thresholdandcumulativelimiterror-ok'}
                            
                            show={true}
                            width={'150px'}
                            height={'38px'}
                            variant={ButtonStyles?.primary}
                           // primary={true}
                            
                            margin={'5px 0px 5px 5px'}
                            fontSize={'13px'}
                            
                            clicked={onClose}
                            mobileMarginTop={
                                (browser === 'Safari' ||
                                    browser === 'Chrome') &&
                                deviceName === 'iPhone'
                                    ? '0px'
                                    : ''
                            }
                            mobileMarginBottom={
                                (browser === 'Safari' ||
                                    browser === 'Chrome') &&
                                deviceName === 'iPhone'
                                    ? '0px'
                                    : ''
                            }
                        >
                            {t(
                                'scheduleSurgery.surgery.notifications.AddedMoreThanTenItems.okButton'
                            )}
                        </Button>
                    )}
                </Div>
            </Popup>
        </>
    );
};

export default ThresholdAndCumulativeLimitError;
